export { Extauth2ForgotPasswordStatus } from './generated/Extauth2ForgotPasswordStatus.js';